import { useEffect, useState } from "react";

import { getFastMarketBoard } from "../../services/user.service";
import EventBus from "../../common/EventBus";
import FastMarketTable from "./table";
import styles from "./styles.module.css";

const BoardFast = () => {
  const [content, setContent] = useState({});

  useEffect(() => {
    getFastMarketBoard().then(
      (response) => {
        setContent(response.data);
      },
      (error) => {
        setContent(
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
            error.message ||
            error.toString()
        );

        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      }
    );
  }, []);

  return (
    <div className={styles.container}>
      {content.comp === "FastMarket" ? <FastMarketTable /> : null}
    </div>
  );
};

export default BoardFast;
